import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses an httpOnly cookie set by the backend (XSS-safe: not readable by JS).
// withCredentials ensures the cookie is sent/received. No token is stored in JS.
const api = axios.create({ baseURL: API, withCredentials: true });

function readCookie(name) {
    const match = document.cookie.match(new RegExp("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)"));
    return match ? decodeURIComponent(match.pop()) : null;
}

// CSRF double-submit: echo the readable csrf_token cookie back as a header on mutations.
api.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    if (["post", "put", "patch", "delete"].includes(method)) {
        const token = readCookie("csrf_token");
        if (token) config.headers["X-CSRF-Token"] = token;
    }
    return config;
});

// Non-sensitive device fingerprint (used for abuse deterrence, not auth). localStorage is fine here.
export function getFingerprint() {
    let fp = localStorage.getItem("omniauc_fp");
    if (!fp) {
        const seed = `${navigator.userAgent}|${navigator.language}|${screen.width}x${screen.height}|${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
        let h = 0;
        for (let i = 0; i < seed.length; i++) {
            h = (h << 5) - h + seed.charCodeAt(i);
            h |= 0;
        }
        fp = `fp_${Math.abs(h)}_${Date.now().toString(36)}`;
        localStorage.setItem("omniauc_fp", fp);
    }
    return fp;
}

export function money(n) {
    if (n === null || n === undefined) return "—";
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
}

export default api;
